import React from "react";

export default function FadeInSection(props) {
  const [isVisible, setVisible] = React.useState(false);
  const domRef = React.useRef();

  React.useEffect(() => {
    const currentRef = domRef.current; // Store the current value of domRef in a variable

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setVisible(entry.isIntersecting);
        }
      });
    });

    if (currentRef) {
      observer.observe(currentRef); // Use the stable reference here
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef); // Cleanup using the stable reference
      }
    };
  }, []); // Empty dependency array means this runs only on mount and unmount

  return (
    <div
      className={`fade-in-section ${isVisible ? "is-visible" : ""}`}
      style={{ transitionDelay: `${props.delay}` }}
      ref={domRef}
    >
      {props.children}
    </div>
  );
}

